// AM Collect — ARCHIVED 2026-07-02.
//
// AM Collect served its purpose and has been retired. The nav entry and intake
// (public token forms + edge-function submissions) are disabled. Historical
// submission data (promoted + un-promoted) is RETAINED read-only in the
// database (am_field_submissions / am_field_promotions / am_collection_tokens).
//
// This notice replaces the former review/promotion routes:
//   /admin/am-collect, /admin/am-collect/history, /admin/am-collect/:submissionId
// so a direct URL visit renders a friendly archived state rather than a broken
// page. The review-module code is retained (dormant) but no longer linked.
// ============================================================================

import { useNavigate } from 'react-router-dom';
import { Archive } from 'lucide-react';
import { Button, EmptyState, PageHeader } from '../../shared/components';

export default function AMCollectArchived() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-3xl p-4 pb-28 sm:p-6">
      <PageHeader title="AM Collect · Archived" meta="Retired 2026-07-02" />
      <EmptyState
        icon={<Archive className="h-6 w-6" />}
        title="AM Collect has been archived"
        body="This collection is closed. New submissions are disabled and the review queue has been retired. Previously collected data was promoted into each facility's record and remains available in Account Management. Historical submissions are retained read-only in the database."
        cta={
          <Button variant="secondary" onClick={() => navigate('/admin')}>
            Back to Admin
          </Button>
        }
      />
    </div>
  );
}
